import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from '../svgs/radarOutline.svg'

const RadarOutline: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 19 19'} component={Icon} {...props} fill="currentColor" />
export default RadarOutline
